import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getMenuPublicationStatus } from '../../api/getMenuPublicationStatus/getMenuPublicationStatus';
import { ILatestPublicationStatusResponse } from '../../api/getMenuPublicationStatus/types';

export const useLatestPublicationStatus = (menuId: string): UseQueryResult<ILatestPublicationStatusResponse> => {
  return useQuery({
    queryKey: ['publicationStatus', menuId],
    queryFn: async () => getMenuPublicationStatus(menuId),
    refetchInterval: (data) => (data?.publication_status === 'PENDING' ? 5 * 1000 : null),
  });
};
